import { addStyles } from 'ethcss'
import { colors, IStyles, palette } from 'theme'
import { mediaCSS } from 'theme/media'

export const styles: IStyles = {
    historyWrapper: {
        [mediaCSS.tab]: {
            paddingTop: 60,
        },
    },
    caption: {
        display: 'flex',
        marginBottom: 14,
        color: colors.blackLight,
        fontSize: 13,
        lineHeight: '18px',
    },
    changeSettings: {
        marginLeft: 16,
        color: colors.blueAccent,
        cursor: 'pointer',
    },
    table: {
        width: '100%',
        overflowX: 'auto',
        borderRadius: 4,
        backgroundColor: colors.white,
    },
    tableHeader: {
        display: 'grid',
        gridTemplateColumns: 'minmax(108px, .7fr) minmax(150px, 1fr) minmax(190px, 1.2fr) minmax(300px, 2.5fr) 36px',
        alignItems: 'center',
        minWidth: 800,
        minHeight: 38,
        padding: '0 10px',
        backgroundColor: palette.neutral[100],
        color: colors.blackLight,
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 500,
    },
    tableRow: {
        display: 'grid',
        gridTemplateColumns: 'minmax(108px, .7fr) minmax(150px, 1fr) minmax(190px, 1.2fr) minmax(300px, 2.5fr) 36px',
        alignItems: 'center',
        minWidth: 800,
        minHeight: 72,
        padding: '8px 10px',
        borderBottom: `1px solid ${colors.greyLight}`,
        color: colors.blackLight,
        fontSize: 13,
        lineHeight: '18px',
        '&:hover': {
            backgroundColor: '#F7F9FC',
        },
    },
    dateCell: {
        display: 'flex',
        flexDirection: 'column',
        whiteSpace: 'nowrap',
    },
    statusCell: {
        color: colors.blueAccent,
        fontSize: 12,
        lineHeight: '16px',
    },
    userCell: {
        display: 'flex',
        minWidth: 0,
        flexDirection: 'column',
        paddingRight: 16,
        '& span': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
        '& span:last-child': {
            color: colors.greyEditor2,
            fontSize: 12,
        },
    },
    eventCell: {
        display: 'flex',
        minWidth: 0,
        flexDirection: 'column',
        paddingRight: 16,
        '& span': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
        '& span:last-child': {
            color: colors.greyEditor2,
            fontSize: 12,
        },
    },
    detailsButton: {
        appearance: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 32,
        height: 32,
        padding: 0,
        border: 0,
        borderRadius: 4,
        background: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: colors.greyLight,
        },
    },
    emptyState: {
        display: 'flex',
        minHeight: 180,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 16,
        color: colors.greyEditor2,
    },
}

addStyles(styles)
